import ReactDOM from "react-dom";
import React from "react";
import InlineTerm from "../components/InlineTerm";

const init = () => {
  document.querySelectorAll(".InlineTerm").forEach(mountPoint => {
    const definition = mountPoint.getAttribute("data-definition");
    const label = mountPoint.innerText;

    ReactDOM.render(
      <InlineTerm term={{ title: label, definition: definition }} />,
      mountPoint
    );
  });
};

// Init on initial page load
init();

